import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { CurrentStateService } from "../services/current-state.service";

export const internalViewGuard: CanActivateFn = () => {
	const router = inject(Router);
	const state = inject(CurrentStateService);

	return state.getCurrentState().pipe(
		map((state) => {
			if (state.school.zfInternalViewSchool === "YES") {
				return true;
			}
			return router.createUrlTree(["dashboard"]);
		}),
	);
};
